class MobileMenu {
    fixedClass = 'layout_fixed'
    scrollYProp = '--viewport-scroll-y'

    constructor() {
        this.onToggle = this.onToggle.bind(this)

        document.querySelector('#mobile-menu-checkbox')
            .addEventListener('change', this.onToggle)
    }

    onToggle(e) {
        if (e.target.checked) {
            this.scrollY = window.scrollY
            document.documentElement.style.setProperty(this.scrollYProp, `${this.scrollY}px`)
            document.body.classList.add(this.fixedClass)
        } else {
            document.body.classList.remove(this.fixedClass)
            document.documentElement.style.removeProperty(this.scrollYProp)
            window.scrollTo({
                top: this.scrollY,
                left: 0,
                behavior: 'instant',
            })
        }
    }
}

export default new MobileMenu()
